export default __webpack_public_path__ + "static/media/equipment-servicing-banner.4bebde18.jpg";